import styled from 'styled-components';

export const SummaryContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  width: 100%;
  padding: 20px;
`;

export const SummaryNestedAccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

export const SummaryContentGrid = styled.div<{ gridColumns?: number }>`
  display: grid;
  row-gap: 20px;
  width: 100%;
  grid-template-columns: ${(props) => `repeat(${props.gridColumns ?? 2}, 1fr)`};
`;

export const ImageContainer = styled.div`
  margin: auto;
  width: 18%;
`;
